* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  color: var(--main-titles-inputs-600);
}

::slotted(*) {
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
}

$smallFontSize: 10, 11, 12, 13;
$fontSize: 14, 16, 18, 20, 22, 24, 32, 36, 48;
$fontWeight: 300, 400, 500, 600, 700;

@each $size in $smallFontSize {
  :host([fontSize='#{$size}']) {
    font-size: calc(#{$size}px + var(--dynamic-small-font-size-changer));
  }
}

@each $size in $fontSize {
  :host([fontSize='#{$size}']) {
    font-size: calc(#{$size}px + var(--dynamic-font-size-changer));
  }
}

@each $weight in $fontWeight {
  :host([fontWeight='#{$weight}']) {
    font-weight: #{$weight};
  }
}
